var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!!_vm.section)?_c('l-geo-json',{attrs:{"geojson":_vm.section,"options-style":_vm.sectionStyle}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }